import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './EditContactModal.css';

const EditContactModal = ({ isOpen, onClose, contact, onUpdate }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (contact) {
      setName(contact.name || contact.profileName || '');
    }
  }, [contact, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!contact) return;

    setLoading(true);
    setError('');

    try {
      const normalizedPhone = (contact.phoneNumber || '').replace(/[+\s\-()]/g, '');
      const response = await axios.put(`/api/contacts/${normalizedPhone}`, {
        name: name.trim() || contact.phoneNumber
      });

      if (response.data.contact) {
        onUpdate(response.data.contact);
        onClose();
      }
    } catch (error) {
      console.error('Error actualizando contacto:', error);
      setError(error.response?.data?.error || 'Error al actualizar el contacto');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="edit-contact-modal-overlay" onClick={onClose}>
      <div className="edit-contact-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-contact-modal-header">
          <h2>Editar Contacto</h2>
          <button className="close-button" onClick={onClose}>✕</button>
        </div>
        
        <form onSubmit={handleSubmit} className="edit-contact-form">
          <div className="form-group">
            <label htmlFor="phoneNumber">Número de teléfono:</label>
            <input
              type="text"
              id="phoneNumber"
              value={contact?.phoneNumber || ''}
              disabled
              className="form-input disabled"
            />
          </div>

          <div className="form-group">
            <label htmlFor="name">Nombre del contacto:</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Ingresa el nombre del contacto"
              className="form-input"
              autoFocus
              maxLength={100}
            />
            <small className="form-hint">
              Este nombre se mostrará en lugar del número de teléfono
            </small>
          </div>

          {error && (
            <div className="error-message">{error}</div>
          )}

          <div className="form-actions">
            <button
              type="button"
              onClick={onClose}
              className="cancel-button"
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="save-button"
              disabled={loading || !name.trim()}
            >
              {loading ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditContactModal;







